import { TrackingContext } from '@vrbo/react-event-tracking';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { createInteractionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import { parseSafe, getSafeHref } from '../../../utils/HtmlUtil';

export function ReadyToList(props) {
    const {
        headline,
        subheadline,
        buttonText,
        buttonLink,
        footer1,
        footer2,
        footer3,
        isFrboFlow
    } = props;
    const { trigger } = useContext(TrackingContext);
    const triggerClickstream = (eventName, actionLocation = '', eventVersion = '1.0.0') => {
        trigger('interaction', createInteractionEvent(`${eventName}.selected`, 'Property Onboarding', '', actionLocation, eventVersion));
        return true;
    };

    const hasFooter2 = !!(footer2?.url && footer2?.text);
    const hasFooter3 = !!(footer3?.url && footer3?.text);

    return (
        <div className="ulx__aem-section ulx__aem-ready-to-list" data-testid="ready-to-list">
            <h2>{headline}</h2>
            <div>{subheadline}</div>
            <a
                href={buttonLink !== 'rtl_link_cta1_list' ? getSafeHref(buttonLink) : '#'}
                onClick={() => (isFrboFlow
                    ? triggerClickstream('property_manager', '')
                    : triggerClickstream('list_your_property', 'bottom', '2.3.0'))}
            >
                <span className="fds-button fds-button-primary">
                    <div className="fds-button-label">{buttonText}</div>
                </span>
            </a>
            <div className="ulx__aem-ready-to-list__cta">
                <div>{parseSafe(footer1)}</div>
                {hasFooter2 && (
                    <div>
                        <a href={getSafeHref(footer2.url)} onClick={() => triggerClickstream('pco_login', '', '2.3.0')}>{footer2.text}</a>
                    </div>
                )}
                {hasFooter3 && (
                    <div>
                        <a
                            className="ulx-footer3-link"
                            href={getSafeHref(footer3.url)}
                            onClick={() => triggerClickstream(isFrboFlow ? 'login' : 'vr_login', '', '2.3.0')}
                        >
                            {footer3.text}
                        </a>
                    </div>
                )}

            </div>
        </div>
    );
}

ReadyToList.propTypes = {
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    footer1: PropTypes.string.isRequired,
    footer2: PropTypes.oneOfType([
        PropTypes.shape({
            url: PropTypes.string,
            text: PropTypes.string
        }),
        PropTypes.oneOf([null])
    ]),
    footer3: PropTypes.oneOfType([
        PropTypes.shape({
            url: PropTypes.string,
            text: PropTypes.string
        }),
        PropTypes.oneOf([null])
    ]),
    isFrboFlow: PropTypes.bool.isRequired
};

ReadyToList.defaultProps = {
    footer2: null,
    footer3: null
};
export default ReadyToList;
